import { render } from "./DeviationEventInput.vue?vue&type=template&id=4850ba34"
import script from "./DeviationEventInput.vue?vue&type=script&lang=ts"
export * from "./DeviationEventInput.vue?vue&type=script&lang=ts"
script.render = render

export default script